<template>
  <div class="demo-mobile-stream">

  </div>
</template>

<script>
  import * as Video from 'twilio-video'
  import CREATE_ROOM from '../graphql/twilio-room/create-room.gql'

  export default {
    mounted() {
      this.$apollo.mutate({
        mutation: CREATE_ROOM
      }).then(({data: {room}}) => {
        this.joinRoom(room)
      })
    },

    methods: {
      joinRoom(roomInfo) {
        Video.connect(roomInfo.token, {name: roomInfo.roomId}).then(room => {
          room.participants.forEach(this.participantConnected);
          room.on('participantConnected', this.participantConnected);
        });
      },

      participantConnected(participant) {
        participant.on('trackSubscribed', track => {
          if (track.kind === 'data') {
            track.on('message', data => {
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
